import React from 'react';
import PropTypes from 'prop-types';
import EstimateReasonModal from '../EstimateReason';

// Thin backwards-compatible wrapper around the generalized EstimateReasonModal.
// Existing call sites pass `lossReasons` and receive `{ lossReason, lossNotes }`.
const LossReasonModal = ({ visible, onCancel, onSubmit, loading, lossReasons }) => {

  const handleSubmit = ({ reason, notes }) => {
    onSubmit({ lossReason: reason, lossNotes: notes });
  };

  return (
    <EstimateReasonModal
      type="loss"
      visible={visible}
      onCancel={onCancel}
      onSubmit={handleSubmit}
      loading={loading}
      reasons={lossReasons}
    />
  );
};

LossReasonModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  lossReasons: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    name: PropTypes.string,
  })),
};

LossReasonModal.defaultProps = {
  loading: false,
  lossReasons: null,
};

export default LossReasonModal;
